import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

// Interfaces para el manejo de versiones
export interface VersionChange {
  number: string;
  date: string;
  description: string;
  changes: string[];
}

export interface AppVersion {
  version: string;
  fecha: string;
  titulo: string;
  versions: VersionChange[];
}

@Injectable({
  providedIn: 'root'
})
export class Constant {

  public message: string = "Ocurrió un error inesperado. Inténtelo de nuevo en unos minutos.";

  // Configuración centralizada de versiones
  private readonly appVersionInfo: AppVersion = {
    version: "3.0.11",
    fecha: "23-05-2026",
    titulo: "GTP - Rastreo Logistica v.3.0.11",
    versions: [
      {
        number: 'Versión 3.0.11',
        date: '23 Mayo 2026',
        description: 'Actualizaciones',
        changes: [
          'IP Developer',
          'Correcciones administración',
          'Correcciones configuraciónes',
        ]
      },
      {
        number: 'Versión 3.0.10',
        date: '24 Marzo 2026',
        description: 'Actualizaciones',
        changes: [
          'Update modulo nivel de combustible',
          'Update acceso al sistema.',
          'Update recorrido',
          'Update Datos Utiles'
        ]
      },
      {
        number: 'Versión 3.0.8',
        date: '11 Febrero 2026',
        description: 'Actualización de filtro velocidades',
        changes: [
          'Update filtros',
        ]
      },
      {
        number: 'Versión 3.0.8',
        date: '02 Enero 2026',
        description: '<strong>Nuevos Modulos, Notificaciones y Actualizaciones:</strong> Diseño Moderno',
        changes: [
            'Notificaciones, alta de configuracion de notificaciones, Whatsapp, Email',
            'Grupos, Creación de Grupos',
            'Accesos al sistema',
            'Importar Puntos, Exportar Puntos',
            'Rutas, Generar y Editar rutas',
            'Buscar lugares',
            'Update configuración movil'
        ]
      },
      {
        number: 'Versión 3.0.7',
        date: '27 Octubre 2025',
        description: '<strong>Nuevos Modulos:</strong> Diseño Moderno',
        changes: [
          'Modulos Nuevos: Rutas, Generacion de Rutas, Buscador de Lugares y Direcciones, Accesos al Sistema, Importar Puntos',
          'Ajustes de diseño: Moderno, Responsivo, Elegante',
          'Ajustes de funcionalidad: Exportar puntos registrados en el sistema',
          'Ajustes de funcionalidad: Importar puntos desde archivo Excel, Base plantilla',
          'Funcionalidades nuevas: Calculo de area, Medir distancia entre dos puntos, Mapa de calor'
        ]
      },
      {
        number: 'Versión 3.0.6',
        date: '14 Octubre 2025',
        description: '<strong>Ajuste de diseño:</strong> Moderno',
        changes: [
          'Modulos: Cuentas, Grupos de referencia y Usuarios',
        ]
      },
      {
        number: 'Versión 3.0.5',
        date: '09 Junio 2025',
        description: '<strong>Renovación Completa del Módulo Distancia Recorrida:</strong> Reportes avanzados con análisis inteligente de eficiencia y consumo, diseño moderno y experiencia mejorada.',
        changes: [
          'Reportes PDF revolucionarios: resumen ejecutivo con estadísticas globales, clasificación automática por distancia (corta, media, larga, extrema)',
          'Análisis inteligente de eficiencia: separación automática entre vehículos eficientes y de alto consumo con umbrales dinámicos',
          'Exportaciones Excel avanzadas: columnas adicionales con categorías automáticas, estadísticas completas y análisis por clasificación',
          'Diseño de botones moderno: colores distintivos (verde para actualizar/Excel, rojo para PDF) con efectos visuales elevados',
          'Experiencia de exportación mejorada: modal centrado con barra de progreso, animaciones y diseño elegante sin interferir con la interfaz',
          'Eliminación de gráficos vacíos: se removió funcionalidad inconsistente de gráficos que no aportaba valor al análisis de datos agregados',
          'Categorización inteligente: clasificación automática por rango de distancia y nivel de eficiencia en combustible',
          'Información detallada por vehículo: vista expandida con clasificaciones y estadísticas individuales completas',
          'Consistencia total: botones y estilos alineados con otros módulos del sistema (paradas, control-velocidad)',
          'Nombres de archivo dinámicos: archivos exportados incluyen automáticamente el período de fechas seleccionado',
          'Estadísticas de clasificación: contadores por categorías con totales y promedios organizados profesionalmente',
          'Interfaz limpia y moderna: eliminación de elementos innecesarios, enfoque en datos útiles y análisis práctico'
        ]
      },
      {
        number: 'Versión 3.0.4',
        date: '27 Mayo 2025',
        description: '<strong>Renovación Completa del Control de Paradas:</strong> Sistema inteligente basado en tiempo operativo con análisis avanzado y reportes mejorados.',
        changes: [
          'Sistema inteligente de clasificación por impacto operativo: prioriza vehículos según el tiempo perdido real, no por cantidad de paradas',
          'Estadísticas globales inteligentes: contadores de paradas cortas (<30min), medias (30min-2h) y largas (>2h) con información de mayor duración',
          'Panel de análisis de tiempo operativo con estados adaptativos: óptimo (verde), atención (naranja) y crítico (rojo)',
          'Clasificación automática de vehículos: una parada de 8 horas es más crítica que 15 paradas de 10 minutos',
          'Explicaciones contextuales individuales que muestran por qué cada vehículo tiene su estado específico',
          'Gráficos interactivos con líneas de referencia para identificar paradas problemáticas visualmente',
          'Exportaciones PDF y Excel completamente renovadas con análisis de productividad y recomendaciones urgentes',
          'Información detallada de tiempo acumulado por categoría en reportes (cantidad + tiempo)',
          'Sistema de recomendaciones automáticas: capacitación, auditoría de rutas y monitoreo intensivo',
          'Métricas avanzadas: índice de productividad, nivel de ociosidad y tiempo perdido total',
          'Interfaz compacta y moderna con mejor aprovechamiento del espacio de pantalla',
          'Consistencia total entre interfaz web y exportaciones usando la misma lógica inteligente'
        ]
      },
      {
        number: 'Versión 3.0.3',
        date: '25 Mayo 2025',
        description: '<strong>Renovación del Control de Velocidad Constante:</strong> Interfaz moderna y estadísticas mejoradas para mejor análisis de excesos.',
        changes: [
          'Diseño completamente renovado con interfaz moderna y atractiva',
          'Estadísticas globales en tiempo real: total de excesos, vehículos afectados, tiempo total y velocidad máxima',
          'Búsqueda inteligente en tiempo real que encuentra información en todos los datos',
          'Indicadores visuales con chips de colores para identificar rápidamente los excesos',
          'Botones de exportación mejorados: PDF en rojo y Excel en verde con estados de carga',
          'Tabla optimizada con iconos informativos y mejor organización de datos',
          'Vista de detalle por vehículo con resumen de estadísticas individuales',
          'Estados vacíos amigables cuando no hay excesos detectados',
          'Diseño compacto y responsive para mejor aprovechamiento del espacio'
        ]
      },
      {
        number: 'Versión 3.0.2',
        date: '24 Mayo 2025',
        description: '<strong>Renovación del Control de Velocidades:</strong> Nuevas funcionalidades y diseño moderno para mejor control de excesos.',
        changes: [
          'Diseño completamente renovado del módulo de control de velocidades',
          'Estadísticas globales con colores diferenciados: verde para vehículos sin excesos, naranja para excesos leves y rojo para excesos severos',
          'Gráfico de velocidades con puntos coloreados: verde para velocidades normales, naranja para velocidades cercanas al límite y rojo para excesos',
          'Información de vehículos más clara mostrando código de equipo de rastreo y matrícula',
          'Mapas duales: enlace directo a Google Maps y ventana modal interna',
          'Clasificación automática de excesos por severidad con iconos y colores distintivos',
          'Diseño responsive optimizado para dispositivos móviles',
          'Tooltips informativos en gráficos que muestran el estado de cada velocidad registrada',
          'Mejor organización de datos para identificar rápidamente vehículos con problemas de velocidad'
        ]
      },
      {
        number: 'Versión 3.0.1',
        date: '23 Mayo 2025',
        description: '<strong>Mejoras Generales del Sistema:</strong> Actualización de mapas, menús y funcionalidades administrativas.',
        changes: [
          'Mapas de calor para visualizar concentraciones de vehículos',
          'Nuevos tipos de vista de mapa: satélite, híbrido y terreno',
          'Herramientas de medición de distancias y áreas en el mapa',
          'Menú administrativo rediseñado con interfaz moderna',
          'Mejoras en dispositivos móviles y diseño responsivo',
          'Optimización del rendimiento general del sistema',
          'Corrección de errores menores y mejoras de usabilidad'
        ]
      },
      {
        number: 'Versión 3.0.0',
        date: '22 Mayo 2025',
        description: '<strong>Actualización Mayor:</strong> Renovación completa de la interfaz y mejoras de rendimiento.',
        changes: [
          'Nuevo diseño de interfaz con mejor usabilidad',
          'Mejoras significativas en el rendimiento del sistema',
          'Implementación de botones de WhatsApp para contacto directo',
          'Actualización del módulo de reportes con nuevas funcionalidades',
          'Corrección de errores conocidos en la versión anterior'
        ]
      }
    ]
  };

  // Getters públicos para acceder a la información de versión
  public get version(): string {
    return this.appVersionInfo.version;
  }

  public get fechaUltAct(): string {
    return this.appVersionInfo.fecha;
  }

  public get titulo(): string {
    return this.appVersionInfo.titulo;
  }

  public get versionesCompletas(): VersionChange[] {
    return this.appVersionInfo.versions;
  }

  public get versionActual(): VersionChange {
    return this.appVersionInfo.versions[0];
  }

  // Método para obtener información completa de versión
  public getVersionInfo(): AppVersion {
    return { ...this.appVersionInfo };
  }

  // Método para actualizar la versión (para futuras actualizaciones)
  public actualizarVersion(nuevaVersion: string, nuevaFecha: string, nuevoCambio: VersionChange): void {
    this.appVersionInfo.version = nuevaVersion;
    this.appVersionInfo.fecha = nuevaFecha;
    this.appVersionInfo.titulo = `GTP - Rastreo Logistica v.${nuevaVersion}`;
    this.appVersionInfo.versions.unshift(nuevoCambio);
  }

  constructor(
      public router: Router,
      private http: HttpClient
) {}

  /**
   * Configuración general del sidebar de Administración
   */
  configMenuSidebar(){
    return {
      fontColor: '#757575',
      classname: 'menuSidebar',
    }
  }

    /**
     * Devuelve dirección de la intersección de los puntos
     * @param lat Latitud del Punto
     * @param long Longitud del Punto
     * @example
     * getDireccion(-25.275518, -57.583820);
     */
    getDireccion(lat, long){
        return this.http.get(`${environment.baseUrl}georeferencia/direccion?latitud=`+lat+`&longitud=`+long);
    }

    getLogoGtp(color?){
        color = (color=='blanco') ? '#01579b' : '#01579B';
        let gtpLogo = `
        <svg id="Group_7" data-name="Group 7" xmlns="http://www.w3.org/2000/svg" width="104.891" height="32.334" viewBox="0 0 104.891 32.334">
            <g fill="${color}">
                <path d="M184.686,186.468a.846.846,0,0,0-.4-.036q-15,0-30,0a18.644,18.644,0,0,0-4.915.578,4.7,4.7,0,0,0-2.885,2.172,10.584,10.584,0,0,0-1.053,2.284,40.662,40.662,0,0,0-1.314,4.939,6.324,6.324,0,0,0-.035,2.3,2.614,2.614,0,0,0,1.574,2.05,9,9,0,0,0,3.142.7c3.069.2,6.142.078,9.213.084a20.314,20.314,0,0,0,4.609-.446,4.452,4.452,0,0,0,3.105-2.073,4.323,4.323,0,0,0,.407-1,9.257,9.257,0,0,0,.183-1.1H153.956c.47-1.842.93-3.644,1.39-5.446.1-.407.228-.81.309-1.222.046-.232.155-.3.367-.27a.5.5,0,0,0,.072,0h22.976l-.62,2.428q-1.123,4.4-2.245,8.8a10.227,10.227,0,0,1-7.692,7.772,30.415,30.415,0,0,1-6.345,1.005c-4.808.292-9.622.1-14.432.145-2.1.022-4.2.015-6.294-.142a13.521,13.521,0,0,1-5.361-1.214,6.666,6.666,0,0,1-3.735-5.8,17.918,17.918,0,0,1,.788-5.94c.677-2.528,1.266-5.081,2.021-7.588a19.148,19.148,0,0,1,3.056-6.2,12.2,12.2,0,0,1,6.64-4.308,30.743,30.743,0,0,1,7.1-1.039c.8-.034,1.607-.053,2.41-.053q26.288,0,52.576,0h.468c-.268,1.041-.529,2.048-.786,3.056-.419,1.641-.846,3.279-1.245,4.925-.081.336-.222.417-.554.415-3.073-.014-6.146,0-9.219-.016-.282,0-.379.081-.448.351q-2.872,11.217-5.758,22.43a.309.309,0,0,1-.363.28q-4.969-.011-9.939,0c-.286,0-.3-.077-.233-.326q1.827-7.006,3.637-14.017,1.08-4.167,2.161-8.334C184.667,186.56,184.676,186.514,184.686,186.468Z" transform="translate(-132.315 -177.815)" />
                <path d="M514.256,183.112a5.119,5.119,0,0,0-1.9-3.595,7.905,7.905,0,0,0-4.024-1.5,34.328,34.328,0,0,0-4.766-.235q-4.338.008-8.677,0a.393.393,0,0,0-.461.357c-.4,1.544-.836,3.081-1.256,4.621-.284,1.042-.559,2.086-.85,3.126-.064.226-.02.319.221.3.083-.008.168,0,.252,0,2.832,0,5.664-.007,8.5,0,1.609.006,2.552.906,2.428,2.4a5.873,5.873,0,0,1-2.509,4.684,4.967,4.967,0,0,1-2.915.938c-5.784-.026-11.569-.012-17.353-.012-.156,0-.312.007-.467.011-1.7,0-3.406,0-5.109-.02-.353,0-.486.1-.578.445-1,3.741-2.026,7.51-3.045,11.247-.3,1.109-.608,2.129-.925,3.4h7.732c.576,0,1.172-.033,1.748-.031.161,0,.345-.011.345-.248v0a3.989,3.989,0,0,1,.214-.93.5.5,0,0,1,.12-.437c.05-.194.1-.388.146-.582-.047-.093.009-.154.063-.216.464-1.689.934-3.376,1.383-5.069a.456.456,0,0,1,.532-.411q8.64.017,17.281.007a19.651,19.651,0,0,0,2.3-.076,12.7,12.7,0,0,0,3.57-.912,10.06,10.06,0,0,0,4.846-4.692,27.553,27.553,0,0,0,2.443-6.452A17.047,17.047,0,0,0,514.256,183.112Z" transform="translate(-409.428 -177.764)" />
                <path d="M567.217,186.21c-.444,0-.888-.01-1.331,0-.208.006-.272-.039-.212-.257q1.084-3.957,2.153-7.919a.257.257,0,0,1,.3-.229c.9.008,1.8.014,2.7,0,.295-.006.268.1.209.319-.647,2.359-1.282,4.722-1.929,7.081-.091.331-.063.787-.324.955-.24.154-.65.044-.984.049C567.6,186.212,567.409,186.21,567.217,186.21Z" transform="translate(-487.062 -177.786)" />
                <path d="M550.345,186.112a5.747,5.747,0,0,1-.971-.037c.08-.325.153-.653.24-.976.642-2.362,1.291-4.722,1.924-7.086.066-.249.168-.323.415-.313.5.019,1.008.02,1.511,0,.3-.011.364.054.278.36-.557,2-1.094,4-1.638,6.007-.163.6-.333,1.2-.486,1.807-.046.182-.124.253-.317.242C551,186.1,550.7,186.112,550.345,186.112Z" transform="translate(-473.736 -177.698)" />
                <path d="M539.264,186.112c.362-1.4.713-2.753,1.067-4.11.345-1.322.7-2.641,1.035-3.967.066-.265.172-.341.434-.337.737.013.74,0,.546.719-.666,2.453-1.34,4.9-1.994,7.359-.075.282-.189.371-.461.339A5.856,5.856,0,0,0,539.264,186.112Z" transform="translate(-465.459 -177.699)" />
            </g>
        </svg>
        `;
        return gtpLogo;
    }

  /**
   * Configuración general del mapa
   */
  mapConfig(){
    return {
      zoomControl: true,
      streetViewControl: true,
      disableDefaultUI: true,
      center: null,
      zoom: 12, //13,
      //polyLineStrokeColor: 'rgba(78,186,117,0.8)',//'#4eba75', //Verde
      polyLineStrokeColor: 'rgba(1,87,155,0.8)',//'#01579B', //Azul
      polyStrokeOpacity: '0.8',
      polyStrokeWeight: '3',
      styles: [
        {
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#e0efef"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "hue": "#1900ff"
                },
                {
                    "color": "#c0e8e8"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": 100
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "lightness": 700
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#7dcdcd"
                }
            ]
        }
      ]
    }
  }

}
